import { render, staticRenderFns } from "./FixedTable.vue?vue&type=template&id=14239fca&"
import script from "./FixedTable.vue?vue&type=script&lang=js&"
export * from "./FixedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports